import { Grid, IconButton, makeStyles } from '@material-ui/core';
import React from 'react';
import VCERNAvatar from './elements/VCERNAvatar';
import docsImage from './assets/others/docsImage.png';
import VCERNTypography from './elements/VCERNTypography';
import icons from './icons';
import { useLocation } from 'react-router';

const useStyles = makeStyles(theme => ({
    docImage: { width: '100%', height: 112.7, marginBottom: 10, objectFit: 'cover' },
    link: { display: 'contents' },
    filename: {
        wordWrap: 'break-word',
        fontSize: 13,
    },
}));

export default function DocumentsList({ docs, setDocToDelete }) {
    const classes = useStyles();
    const location = useLocation();
    console.log({ docs });
    return (
        <Grid container spacing={3}>
            {docs.map((el, idx) => {
                const filename = el.file.split('/')[el.file.split('/').length - 1];
                const filenameFragments = filename.split('-');
                filenameFragments.shift();
                let filenameToDisplay = filenameFragments.join('-');
                return (
                    <Grid style={{ position: 'relative' }} item key={idx} sm={6} md={3} lg={2}>
                        <a className={classes.link} href={el?.file} target="_blank" rel="noreferrer" download>
                            <VCERNAvatar className={classes.docImage} variant="rounded" src={el?.type === 'image' ? el?.file : docsImage} />
                            <VCERNTypography variant="p" className={classes.filename}>
                                {filenameToDisplay}
                            </VCERNTypography>
                        </a>
                        {location.pathname.includes('documents') && (
                            <IconButton style={{ position: 'absolute', top: 0, left: 0, color: 'red' }} onClick={() => setDocToDelete(el._id)}>
                                {icons.cancel}
                            </IconButton>
                        )}
                    </Grid>
                );
            })}
        </Grid>
    );
}
